import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

type Props = {
  workStatus: string
  setWorkStatus: React.Dispatch<React.SetStateAction<string>>
  workStatusOptions: { label: string, value: string }[]
}

const WorkStatusInput: React.FC<Props> = ({ workStatus, setWorkStatus, workStatusOptions }) => {
  return (
    <FormControl sx={{ width: '20rem' }}>
      <InputLabel id="status-select-label" shrink>Status da atividade</InputLabel>
      <Select
        labelId="status-select-label"
        value={workStatus}
        onChange={(event) => setWorkStatus(event.target.value)}
        label="Status da atividade"
        displayEmpty
      >
        <MenuItem value="">
          Todos
        </MenuItem>
        {workStatusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
      {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default WorkStatusInput
